export default [
  {
    path: '/real-estate-developments/:id',
    component: () => import('layouts/RealEstateDevelopmentsLayout.vue'),
    children: [
      {
        path: 'edit',
        name: 'RealEstateDevelopmentsEdit',
        component: () => import('pages/real-estate-developments/form/RealEstateDevelopmentsForm.vue')
      },
      {
        path: 'parameters',
        name: 'RealEstateDevelopmentsParametersList',
        component: () => import('pages/real-estate-developments/tabs/parameters/ParametersList.vue')
      },
      {
        path: 'characteristics',
        name: 'RealEstateDevelopmentsCharacteristicsList',
        component: () => import('pages/real-estate-developments/tabs/characteristics/CharacteristicsList.vue')
      },
      {
        path: 'documents',
        name: 'RealEstateDevelopmentsDocumentsList',
        component: () => import('pages/real-estate-developments/tabs/documents/DocumentsList.vue')
      },
      {
        path: 'medias',
        name: 'RealEstateDevelopmentsMediasList',
        component: () => import('pages/real-estate-developments/tabs/medias/MediasList.vue')
      },
      {
        path: 'accessories',
        name: 'RealEstateDevelopmentsAccessoriesList',
        component: () => import('pages/real-estate-developments/tabs/accessories/AccessoriesList.vue')
      },
      {
        path: 'units',
        name: 'RealEstateDevelopmentsUnitsList',
        component: () => import('pages/real-estate-developments/tabs/units/UnitsList.vue')
      },
      {
        path: 'stages',
        name: 'RealEstateDevelopmentsStagesList',
        component: () => import('pages/real-estate-developments/tabs/stages/StagesList.vue')
      },
      {
        path: 'typologies',
        name: 'RealEstateDevelopmentsTypologiesList',
        component: () => import('pages/real-estate-developments/tabs/typologies/TypologiesList.vue')
      },
      {
        path: 'mirrors',
        name: 'RealEstateDevelopmentsMirrorsList',
        component: () => import('pages/real-estate-developments/tabs/mirrors/MirrorsList.vue')
      },
      {
        path: 'blueprints',
        name: 'RealEstateDevelopmentsBlueprintsList',
        component: () => import('pages/real-estate-developments/tabs/blueprints/BlueprintsList.vue')
      },
      {
        path: 'transfer/edit',
        name: 'RealEstateDevelopmentsTransferEdit',
        component: () => import('pages/real-estate-developments/tabs/transfer/RealEstateDevelopmentsTransferEdit.vue')
      }
    ]
  }
]
